import React, { useState, useEffect, useRef } from 'react';
import './header.css';
import menuIcon from "../../ui/assets/images/menu-icon.png";
import { useNavigate, useLocation } from 'react-router-dom';
import { removeUserCredentials } from "../Utils/authUtils"
import { useTheme } from '../../ui/src/contextProviders';
import { Icon, ICONS } from '@ohif/ui';
import { NavLink } from 'react-router-dom';
// import '../global.css'
import { _auditUrls } from '@custom/Utils/constants/apiUrls';
import { permissionState } from '@custom/Utils/constants/permission';
import { _routes } from '../Utils/constants/routes';
import "../custom.css"
import { HeaderProps } from '@custom/Utils/constants/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import getNotificationCount from '@custom/rtk-apis/report/notificationCount';
import { _roleType } from '@custom/Utils/constants/appConstants';
import getDiscountRequestsApi from '@custom/rtk-apis/billing/discountNotification/getDiscountRequests';
import { graceperiod } from '@custom/constant';

const capitalizeName = (name: string) => {
  return name.replace(/\b\w/g, char => char.toUpperCase());
};

const Header = ({ title, isBack, handleIsBackFunctionality }: HeaderProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { status, result, msg, loading, error } = useSelector((state: RootState) => state?.getNotificationCountResponse);
  const getDiscountRequestsData = useSelector((state: RootState) => state.getDiscountRequestsResponse);
  const { isDarkMode, toggleTheme } = useTheme();
  const [userName, setUserName] = useState<string | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const overlayRef = useRef(null);
  const [activeLink, setActiveLink] = useState(null);
  const [menu, setMenu] = useState([])
  const [showDropdown, setShowDropdown] = useState(false);
  const location = useLocation();
  const [pendingDiscountReqCount, setPendingDiscountReqCount] = useState(0);
  const storedUserRole = sessionStorage.getItem('role') || localStorage.getItem('role');
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);

  useEffect(() => {
    // Fetch the user name from sessionStorage
    const storedUserName = sessionStorage.getItem('name') || localStorage.getItem('name');
    const storedUserId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    if (storedUserName) {
      setUserName(capitalizeName(storedUserName));
    } else {
      setUserName('Guest');
    }
    const storedUserRole = sessionStorage.getItem('role') || localStorage.getItem('role');
    const hospitalType = sessionStorage.getItem("hospitalType") || localStorage.getItem('hospitalType');
    let roleToCheck = hospitalType === 'teraradiology' && (storedUserRole === 'Resident' || storedUserRole === 'Radiologist') ? 'teleradiologistUser' : storedUserRole ? storedUserRole.replace(/\s+/g, '').toLowerCase() : null;
    // Add a case in case of telepathologist
    if (hospitalType == "teraradiology" && storedUserRole == _roleType.pathologist) {
      roleToCheck = 'telepathologist';
    } else if (hospitalType == "teraradiology" && storedUserRole == _roleType.radiologistAdmin) {
      roleToCheck = 'radiologistAdmin';
    } else if (hospitalType == "teraradiology" && storedUserRole == _roleType.pathologistAdmin) {
      roleToCheck = 'pathologistAdmin';
    }
    if(hospitalDetailsData?.result?.subscriptionDetail?.daysLeftForExpiration < graceperiod && storedUserRole === _roleType.hospitalSuperadmin){
      setMenu([{
        iconName: "user-side-menu",
        redirectTo: '/edithospital',
        routeName: 'Clinic / Hospital Profile'
      }])
    } else {
      let tempArray = permissionState[roleToCheck]?.navLink
      setMenu(tempArray)
    }

    dispatch(getNotificationCount());
  }, [hospitalDetailsData?.result]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false)
  }
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const redirectToPage = (route) => {
    setActiveLink(route)
    setIsMenuOpen(false)
    navigate(route)

  }
  const logout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('hospitalCode');
    localStorage.removeItem('hospitalType');
    removeUserCredentials();

    localStorage.setItem("isLightMode", "true");
    localStorage.setItem("selectedTheme", "light");

    const body = document.body;
    body.classList.remove('dark-theme');
    body.classList.add('light-theme');

    if (typeof toggleTheme === 'function' && isDarkMode) {
      toggleTheme();
    }

    setIsMenuOpen(false);
    navigate("/login");

  }
  const handleClickOutSide = (event) => {

    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutSide)
    }
  }, [isMenuOpen])

  const handleBackClickButton = () => {
    if (isBack && handleIsBackFunctionality) {
      handleIsBackFunctionality();
    } else if (isBack) {
      if (title === "Edit Teleradiology Profile") {
        window.location.reload();
      } else if (window.history.length > 1) {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    const body = document.body;
    if (!isDarkMode) {
      // Remove dark theme and add light theme
      body.classList.remove('dark-theme');
      body.classList.add('light-theme');
    } else {
      // Remove light theme and add dark theme
      body.classList.remove('light-theme');
      body.classList.add('dark-theme');
    }
    localStorage.setItem("isLightMode", isDarkMode ? String(false) : String(true));
    localStorage.setItem("selectedTheme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  useEffect(() => {
    dispatch(getDiscountRequestsApi()).unwrap()
  }, []);

  useEffect(() => {
    if (getDiscountRequestsData?.status === "success") {
      const pendingRequests = getDiscountRequestsData?.result?.filter(request => request?.discountRequest?.status === "Pending");
      setPendingDiscountReqCount(pendingRequests?.length);
    }
  }, [getDiscountRequestsData]);

  return (
    <div className="page__head ">
      <div className="page__head__colLeft">
        <button className="menu-button" onClick={toggleMenu}>
          <img style={
            isDarkMode ? { filter: 'invert(1)' } : null
          } src={menuIcon}></img>
        </button>

        <div className='page__head--title'>
          {isBack && <img onClick={handleBackClickButton} style={
            isDarkMode ? { filter: 'invert(1)' } : null
          } src={ICONS.back} />}
          {title}
        </div>
      </div>

      <div ref={overlayRef} className={`layoutSidemenu ${isMenuOpen ? 'layoutSidemenu--open' : ''}`}>
        <div className="layoutSidemenu__logo">
          <img src={ICONS.SevenHillsLogo} alt="Logo | Seven Hills" />
        </div>
        <div className="layoutSidemenu__fullHeight">
          <ul className="layoutSidemenu__list">
            {menu?.map((item, index) => (
              <li key={index}>
                <div
                  className={`layoutSidemenu__list--item ${(item.routeName !== 'Settings' && activeLink === item.redirectTo) ||
                    (item.routeName === 'Settings' && (activeLink === '/settings/reports' || activeLink === '/machines' || activeLink === '/frontdeskmachine' || activeLink === '/pacs'))
                    ? 'layoutSidemenu__selected'
                    : ''
                    }`} onClick={() => {
                      if (item.routeName === 'Settings') {
                        setShowDropdown(!showDropdown);
                        //  setActiveLink(item.redirectTo)
                      } else {
                        redirectToPage(item.redirectTo);
                      }
                    }}
                >
                  {item.routeName === 'Settings' ? (
                    <div className="layoutSidemenu__list--link flex items-center justify-between" style={{ justifyContent: 'space-between' }}>
                      <div className='flex items-center'>
                        <span className="icon mr-2">
                          <Icon name={item.iconName}></Icon>
                        </span>
                        {item.routeName}
                      </div>
                      <span className="icon chevron-icon" style={{ transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                        <Icon name="chevron-down"></Icon>
                      </span>
                    </div>
                  ) : (
                    <NavLink
                      className="layoutSidemenu__list--link flex items-center justify-between"
                      to={item.redirectTo}
                      style={{ justifyContent: 'space-between' }}
                    >
                      <div className="flex items-center">
                        <div className="flex items-center mr-5">
                          <span className="icon mr-2">
                            <Icon name={item.iconName}></Icon>
                          </span>
                          <p>{item.routeName}</p>
                        </div>
                        {item.routeName === "My Worklist" && result?.notificationCount > 0 && (
                          <div className="badge">
                            <p>{result?.notificationCount}</p>
                          </div>
                        )}
                        {item.routeName === "Discount Requests" && pendingDiscountReqCount > 0 && (
                          <div className="badge">
                            <p>{pendingDiscountReqCount}</p>
                          </div>
                        )}
                      </div>
                    </NavLink>
                  )}
                </div>
                {/* Sub-menu Dropdown */}
                {item.routeName === 'Settings' && showDropdown && (
                  <ul className="layoutSidemenu__dropdown">
                    {item.subMenu.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        className={`layoutSidemenu__list--item ${activeLink === subItem.redirectTo ? 'layoutSidemenu__selected' : ''
                          }`}

                      >
                        <NavLink
                          className="layoutSidemenu__list--link flex items-center justify-between"
                          to={subItem.redirectTo}
                          onClick={() => redirectToPage(subItem.redirectTo)}
                        >
                          <div className='flex items-center'>
                            {subItem.routeName}
                          </div>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

          </ul>
        </div>
        <div className="layoutSidemenu__version">
          <h4 className="layoutSidemenu__version__title" onClick={logout}>
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V3C12 2.46957 11.7893 1.96086 11.4142 1.58579C11.0391 1.21071 10.5304 1 10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V15C1 15.5304 1.21071 16.0391 1.58579 16.4142C1.96086 16.7893 2.46957 17 3 17H10C10.5304 17 11.0391 16.7893 11.4142 16.4142C11.7893 16.0391 12 15.5304 12 15V13" stroke="#E53761" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 9H19L16 6" stroke="#E53761" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M16 12L19 9" stroke="#E53761" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Logout
          </h4>
        </div>
      </div>
      <div className="page__head__colRight">
        {result?.notificationCount > 0 && location.pathname !== '/worklist' && (storedUserRole === 'Radiologist' || storedUserRole === 'Pathologist') && (
          <div className="notification-count" style={{ marginRight: '10px' }}>
            <span style={{ color: isDarkMode ? '#fff' : '#006400' }}>Review Report: {result.notificationCount}</span>
          </div>
        )}
        {storedUserRole !== 'Radiologist' && (
          pendingDiscountReqCount > 0 && (
            <div className="notification-count" style={{ marginRight: '10px' }}>
              <span style={{ color: isDarkMode ? '#fff' : '#006400' }}>Pending Discount Request: {pendingDiscountReqCount}</span>
            </div>
          )
        )}
        <label className="inline-flex items-center cursor-pointer mt-0" style={{ marginRight: "5px" }}>
          <input type="checkbox" value="" checked={isDarkMode} className="sr-only peer" onChange={toggleTheme} />
          <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 darkLightMode"></div>
          {/* <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Dark Mode</span> */}
        </label>
        <button className="user-button">

          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="7.58337" r="2.875" fill="#0F8491" fill-opacity="0.1" stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <circle cx="9.5" cy="9.5" r="8.625" stroke="white" stroke-width="1.5" />
            <path d="M15.25 15.9265C14.9108 14.9076 14.1635 14.0073 13.1239 13.3652C12.0842 12.7231 10.8104 12.375 9.5 12.375C8.18958 12.375 6.91577 12.7231 5.87614 13.3652C4.83651 14.0073 4.08916 14.9076 3.75 15.9265" stroke="white" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          {userName}{isDarkMode}
        </button>
      </div>

    </div>
  );
};

export default Header;
